// =========================================
// Price List — Category Filter + Infinite Scroll
// =========================================
document.addEventListener('DOMContentLoaded', function () {
    const block = document.querySelector('.block-price-list');
    if (!block) return;

    const filterBtns = block.querySelectorAll('.price-filter-btn');
    const allRows    = block.querySelectorAll('.price-row');
    const container  = block.querySelector('.price-list-rows');
    if (!container) return;

    const INITIAL_COUNT = 10;
    const LOAD_MORE     = 5;

    // ── Infinite scroll helpers ──────────────────────────────────────

    let visibleRows = [];   // rows matching the current filter
    let shownCount  = 0;    // how many are currently visible

    function getFilteredRows(category) {
        const rows = [];
        allRows.forEach(function (row) {
            if (category === 'all' || row.dataset.category === category) {
                rows.push(row);
            }
        });
        return rows;
    }

    function hideAll() {
        allRows.forEach(function (row) {
            row.hidden = true;
            row.classList.remove('is-visible');
        });
    }

    function showNext(count) {
        const end = Math.min(shownCount + count, visibleRows.length);
        for (let i = shownCount; i < end; i++) {
            visibleRows[i].hidden = false;
            // Stagger fade-in
            (function (row, delay) {
                setTimeout(function () {
                    row.classList.add('is-visible');
                }, delay);
            })(visibleRows[i], (i - shownCount) * 60);
        }
        shownCount = end;
        updateSentinel();
    }

    // ── Scroll sentinel (triggers loading more) ─────────────────────

    const sentinel = document.createElement('div');
    sentinel.className = 'price-list-sentinel';
    sentinel.setAttribute('aria-hidden', 'true');
    container.appendChild(sentinel);

    function updateSentinel() {
        sentinel.hidden = shownCount >= visibleRows.length;
    }

    const observer = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting && shownCount < visibleRows.length) {
            showNext(LOAD_MORE);
        }
    }, { rootMargin: '200px 0px' });

    observer.observe(sentinel);

    // ── Apply filter (called on init + button click) ────────────────

    function applyFilter(category) {
        hideAll();
        visibleRows = getFilteredRows(category);
        shownCount = 0;
        showNext(INITIAL_COUNT);
    }

    // ── Filter button clicks ────────────────────────────────────────

    filterBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
            const category = this.dataset.category;
            filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
            this.classList.add('is-active');
            applyFilter(category);
        });
    });

    // ── Init: check URL hash for pre-selected category ────────────
    var initCategory = 'all';
    var hash = window.location.hash.replace('#', '');
    if (hash) {
        // Find a filter button matching the hash
        filterBtns.forEach(function (btn) {
            if (btn.dataset.category === hash) {
                initCategory = hash;
                filterBtns.forEach(function (b) { b.classList.remove('is-active'); });
                btn.classList.add('is-active');
            }
        });
    }
    applyFilter(initCategory);
});
